const slideShow = document.querySelector('.js-hero-rotation');


const init = function () {
	if (document.body.contains(slideShow)) {
		setInterval(fadeToNextImage, 8000);
	}
};


const fadeToNextImage = function () {

	const activeSlide = slideShow.querySelector('.is-active');
	let nextSlide = activeSlide.nextElementSibling;

	if (nextSlide === null) {
		nextSlide = slideShow.firstElementChild;
	}

	activeSlide.classList.remove('is-active');
	nextSlide.classList.add('is-active');

};


const api = {
	init: init
};

export default api;